import React, { Component } from "react";
import UserService from "../services/user.service";
import { connect } from "react-redux";
import ContentHeader from "./content-header.component";
import Sidebar from "./sidebar.component";
import Loader from "./Loader-component";
import { Coins } from "../config/clientconfig";
import Header from "./Header.component";
import { ToastContainer, toast } from "react-toastify";
import { Redirect } from "react-router-dom";
import Highcharts from "highcharts";
import { HighchartsSparkline, withHighcharts, AreaSeries, Tooltip } from "react-jsx-highcharts";
import axios from "axios";
class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            coinDetail: [],
            isLoading: true,
            cointicker: "",
            fiat_currency: "usd",
        };
    }
    async componentWillMount() {
        var cointkr = this.props.match.params.coin;
        if (cointkr == undefined || cointkr == "") {
            this.setState({
                cointicker: "VSOL",
            });
            cointkr = "VSOL";
        } else {
            this.setState({
                cointicker: cointkr,
            });
        }
        await this.loadDetail();
    }

    handleChange = async (event) => {
        this.setState(
            {
                fiat_currency: event.target.value,
            },
            () => {
                this.loadDetail().then(() => {
                    this.setState({ isLoading: false });
                });
            }
        );
    };

    loadDetail = async () => {
        var coindetailresp = await UserService.getCoindetail();
        const coindetal = coindetailresp.data.coinDetail;
        let i;
        let newlistdata = [];
        for (i = 0; i < coindetal.length; i++) {
            var objcoin = {};
            objcoin["Ticker"] = coindetal[i].Ticker;
            objcoin["Addresses"] = coindetal[i].Addresses;
            objcoin["Coinname"] = coindetal[i].Coinname;
            objcoin["ConfirmedBalance"] = coindetal[i].ConfirmedBalance;
            objcoin["Priceapi"] = coindetal[i].Priceapi;
            objcoin["Ticker"] = coindetal[i].Ticker;
            objcoin["Addresses"] = coindetal[i].Addresses;
            var resp = await axios.get(coindetal[i].Priceapi.replace("usd", this.state.fiat_currency));
            if (resp.data.length == 1) {
                objcoin["Confirmed_USDBalance"] = (parseFloat(coindetal[i].ConfirmedBalance) * parseFloat(resp.data[0].current_price)).toFixed(4);
                objcoin["change_percentage_24h"] = resp.data[0].price_change_percentage_24h_in_currency;
                objcoin["Chartdata"] = resp.data[0].sparkline_in_7d.price;
                if (resp.data[0].price_change_percentage_24h_in_currency < 0) {
                    objcoin["color"] = "#ee1044";
                } else {
                    objcoin["color"] = "#18d26b";
                }
            }
            newlistdata.push(objcoin);
        }
        this.setState({
            coinDetail: newlistdata,
            isLoading: false,
        });
    };

    render() {
        const { user: currentUser } = this.props;

        if (!currentUser) {
            return <Redirect to="/login" />;
        }

        return (
            <div className="sitemain">
                <Sidebar coin={this.state.cointicker} />
                <main className="main-content">
                    <div className="position-relative">
                        {/* <Header /> */}
                        <nav className="nav navbar navbar-expand-lg navbar-light iq-navbar">
                            <div className="container-fluid navbar-inner">
                                <a href="/" className="navbar-brand">
                                    <img src="../assets/images/NOVA-1.png" alt="Nova Wallet" className="logo-img nova-navbar-logo" />
                                </a>
                                <div className="sidebar-toggle" data-toggle="sidebar" data-active="true">
                                    <i className="icon">
                                        <svg width="20px" height="20px" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                        </svg>
                                    </i>
                                </div>

                                <button
                                    className="navbar-toggler"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent"
                                    aria-controls="navbarSupportedContent"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                >
                                    <span className="navbar-toggler-icon">
                                        <span className="navbar-toggler-bar bar1 mt-2"></span>
                                        <span className="navbar-toggler-bar bar2"></span>
                                        <span className="navbar-toggler-bar bar3"></span>
                                    </span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul className="navbar-nav ms-auto align-items-center navbar-list mb-2 mb-lg-0">
                                        <li>
                                            <select className="form-select form-select-sm mb-3 shadow-none" value={this.state.fiat_currency} onChange={this.handleChange}>
                                                <option value="usd">USD</option>
                                                <option value="gbp">GBP</option>
                                                <option value="eur">EUR</option>
                                            </select>
                                        </li>
                                        <li className="nav-item nova-confrmo-nav">
                                            <a href="https://www.confrmo.com" target="_blank" rel="noopener noreferrer" aria-label="Visit Confrmo">
                                                <img src="../assets/images/confrmo.png" alt="Confrmo" />
                                            </a>
                                        </li>
                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href="https://coinmarketcap.com/currencies/vsolidus/" target="_blank">
                                                <img
                                                    src="../assets/images/coinmarketcap.png"
                                                    alt="CoinMarketcap"
                                                    style={{ width: "50px", height: "50px" }}
                                                    className="img-fluid avatar avatar-50 avatar-rounded"
                                                />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href="https://www.coingecko.com/en/coins/vsolidus" target="_blank">
                                                <img
                                                    src="../assets/images/coingeco.png"
                                                    alt="CoinGeco"
                                                    style={{ width: "50px", height: "50px" }}
                                                    className="img-fluid avatar avatar-50 avatar-rounded"
                                                />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href={"https://www.bitmart.com/trade/en?symbol=VSOL_USDT&layout=basic"} target="_blank">
                                                <img src="../assets/images/bitmart.png" alt="BitMart" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href={"https://www.bibox.com/en/exchange/basic/VSOL_USDT"} target="_blank">
                                                <img src="../assets/images/bibox.png" alt="BiBox" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li>

                                        {/* 
										<li className="nav-item ">
											<a className="nav-link py-0 d-flex align-items-center" href="https://www.xt.com/tradePro/vsol_usdt" target="_blank" >
												<img src="../assets/images/xt.png" alt="XT" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
											</a>
										</li>

										<li className="nav-item ">
											<a className="nav-link py-0 d-flex align-items-center" href="https://www.hotbit.io/exchange?symbol=VSOL_USDT" target="_blank" >
												<img src="../assets/images/hotbit.png" alt="Hotbit" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
											</a>
										</li> */}
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        <ContentHeader coin={this.state.cointicker} fiat_currency={this.state.fiat_currency} pagename={"Dashboard"} />
                    </div>
                    {this.state.isLoading ? (
                        <Loader />
                    ) : (
                        <div className="conatiner-fluid content-inner mt-n5 py-0">
                            <div className="row">
                                {this.state.coinDetail.map((data, index) => (
                                    <div className="col-xl-4 col-xxl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 m-t35 animated zoomInDown" key={index}>
                                        <a href={"/wallet/" + data.Ticker} className="Acontent">
                                            <div className="card card-coin">
                                                <div className="card-body text-center">
                                                    <img className="mb-3 currency-icon" src={"../assets/images/coins/" + data.Ticker + ".png"} style={{ width: "80px", height: "80px" }} />
                                                    <h2 className="text-black mb-3 font-w600">{data.ConfirmedBalance + "   " + data.Ticker} </h2>
                                                    <div className="row sp20 mb-2 align-items-center">
                                                        <div className="d-flex col-lg-12 col-xxl-12 col-sm-12  col-xs-12 align-items-center mt-sm-0 mt-3 justify-content-center">
                                                            <div className="px-2 info-group">
                                                                <p className="fs-14 mb-1">{this.state.fiat_currency.toUpperCase()} Balance</p>
                                                                <h3 className="fs-20 font-w600 text-black"> {parseFloat(data.Confirmed_USDBalance)}</h3>
                                                                {/* <b style={{"fontSize":"14px","fontWeigt":"600"}}> {this.state.fiat_currency.toUpperCase()} </b> */}
                                                            </div>
                                                            <div className="px-2 info-group">
                                                                <p className="fs-14 mb-1">24h% change</p>
                                                                {data.change_percentage_24h > 0 ? (
                                                                    <h3 className="fs-20 font-w600">
                                                                        <span className="text-success">{data.change_percentage_24h.toFixed(2)} %</span>
                                                                        <i className="fa fa-caret-up scale5 ml-2 text-success" aria-hidden="true"></i>
                                                                    </h3>
                                                                ) : (
                                                                    <h3 className="fs-20 font-w600">
                                                                        <span className="text-danger">{data.change_percentage_24h == null ? 0 : data.change_percentage_24h.toFixed(2)}% </span>
                                                                        <i className="fa fa-caret-down scale5 ml-2 text-danger" aria-hidden="true"></i>
                                                                    </h3>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row sp20 mb-2 align-items-center">
                                                        <HighchartsSparkline height="80" width="450" series={<AreaSeries name={data.Ticker} data={data.Chartdata} color={data.color} />}>
                                                            <Tooltip
                                                                outside
                                                                borderWidth={3}
                                                                shadow={false}
                                                                hideDelay={0}
                                                                padding={8}
                                                                headerFormat={`<b>${data.Ticker}:</b> `}
                                                                pointFormat={"{point.y:,.6f}"}
                                                            />
                                                        </HighchartsSparkline>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="footer text-center pl-2">
                        <div className="footer-body">
                            <ul className="left-panel list-inline mb-0 p-0">
                                <li className="list-inline-item">
                                    <a href="https://vsolidus.com/copyrightpolicy/" target="_blank">
                                        Copyright Policy
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://vsolidus.com/termsandconditions/" target="_blank">
                                        Terms and Conditions
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://www.vsolidusacademy.com" target="_blank">
                                        VSolidus Academy
                                    </a>
                                </li>
                            </ul>
                            <div className="right-panel">
                                <p>
                                    Copyright ©{" "}
                                    <a href="/" target="_blank">
                                        Nova Web Wallet
                                    </a>{" "}
                                    2026
                                </p>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.auth;
    return {
        user,
    };
}

export default connect(mapStateToProps)(withHighcharts(Dashboard, Highcharts));
